import { ListItem, ListItemText } from '@material-ui/core';
import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';

import CheckCircleIcon from 'assets/icons/check-circle.svg';
import { selectUser } from 'entities/user/selectors';
import Img from 'retired/Img';
import { purple } from 'utils/color-styles';
import { computeDonationProviderForNonprofit } from 'utils/computeDonationProviderForNonprofit';
import { getDonationProviderDisplayName } from 'utils/getDonationProviderDisplayName';

const Option = ({
  nonprofit,
  getDisplayDonationProviderForNonprofit = computeDonationProviderForNonprofit,
}): ReactElement => {
  const locationObject = nonprofit.get('locationObject');
  const location = locationObject?.get('city')
    ? [
        locationObject.get('address'),
        locationObject.get('city'),
        locationObject.get('state') &&
          locationObject.get('postalCode') &&
          `${locationObject.get('state')} ${locationObject.get('postalCode')}`,
      ]
        .filter(Boolean)
        .join(', ')
    : '';
  const user = useSelector(selectUser);
  const preferStripe = user?.organization?.settings?.get('preferStripe') || false;

  const displayDonationProviderCode = getDisplayDonationProviderForNonprofit(
    nonprofit,
    preferStripe
  );
  const displayDonationProviderName = getDonationProviderDisplayName(displayDonationProviderCode);
  const showPoweredBy = user?.isAdmin || false;

  return (
    <ListItem title={nonprofit.get('name')}>
      <ListItemText
        primary={
          <div style={{ display: 'flex' }}>
            <div style={{ color: purple }}>
              {nonprofit.get('name')}{' '}
              {nonprofit.get('ein') ? <> – EIN: {nonprofit.get('ein')}</> : null}
            </div>

            {nonprofit.get('approved') && (
              <Img
                src={CheckCircleIcon}
                style={{
                  width: '20px',
                  marginLeft: 6,
                }}
                alt="Approved"
                title="Approved"
              />
            )}
          </div>
        }
        secondary={
          <>
            {location}
            {showPoweredBy && displayDonationProviderName && (
              <>
                <br />
                Powered by: {displayDonationProviderName}
              </>
            )}
          </>
        }
      />
    </ListItem>
  );
};

export default Option;
